// Mock data for Mai El Mokadem - Writer & Journalist Portfolio
// All content here is mocked and will later be replaced by API/CMS data.

export const writer = {
  name: "MAI EL MOKADEM",
  shortName: "Mai",
  role: "Writer & Journalist",
  taglineLines: ["COVER STORIES", "MUSIC", "FASHION", "ARTS & CULTURE"],
  location: "Cairo \u2192 Worldwide",
  email: "maielmokadem@outlook.com",
  instagram: "maielmokadem_",
  instagramUrl: "https://instagram.com/maielmokadem_",
  issue: "ISSUE \u2116 26",
  year: "2026",
};

export const profileAuthorityLinks = [
  {
    label: "SceneNow Writer Profile",
    publication: "SceneNow",
    url: "https://scenenow.com/WriterProfile/2130",
  },
  {
    label: "International Music Summit Speaker Profile",
    publication: "International Music Summit",
    url: "https://www.internationalmusicsummit.com/ims-speakers/mai-el-mokadem",
  },
];

export const heroPortrait =
  "https://images.unsplash.com/photo-1561455852-431358491c3c?crop=entropy&cs=srgb&fm=jpg&w=940&h=1175&q=85";

export const aboutPortrait =
  "https://images.pexels.com/photos/31167801/pexels-photo-31167801.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1100&w=940";

export const collagePages = {
  dazed: "https://customer-assets.emergentagent.com/job_byline-mag/artifacts/np6e07v9_image.png",
  yung: "https://customer-assets.emergentagent.com/job_byline-mag/artifacts/albncmqp_image.png",
  thisisyung: "https://customer-assets.emergentagent.com/job_byline-mag/artifacts/06esor3q_image.png",
  styled1: "https://customer-assets.emergentagent.com/job_byline-mag/artifacts/0h2gqlqt_image.png",
  styled2: "https://customer-assets.emergentagent.com/job_byline-mag/artifacts/ek5uh4rh_image.png",
};

export const featuredCover = {
  id: "feat-1",
  kicker: "COVER STORY \u2014 DAZED MENA",
  title: "Welcome to the Habibification of House Music",
  dek:
    "From Adam Port \u00d7 Amr Diab to desert raves at the Pyramids \u2014 inside the cultural turning point reshaping how the world hears Arab sound.",
  category: "Music \u2022 Cultural Commentary",
  publication: "Dazed MENA",
  date: "2025",
  image: "https://customer-assets.emergentagent.com/job_byline-mag/artifacts/np6e07v9_image.png",
  pullQuote:
    "Habibification refers to the flattening of Arab sonic identity into an aesthetic.",
  stats: [
    { label: "TikTok likes", value: "19K+" },
    { label: "Instagram", value: "7.8K" },
    { label: "Panel", value: "Dubai" },
  ],
};

export const articles = [
  {
    id: "a-1",
    title: "In the Arab World, Love Walks on Tiptoe",
    slug: "in-the-arab-world-love-walks-on-tiptoe",
    publication: "This Is YUNG",
    category: "Culture",
    excerpt:
      "On gendered intimacy, surveillance, and the quiet choreography of desire across the MENA region.",
    image:
      "https://images.pexels.com/photos/36176350/pexels-photo-36176350.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940",
    accent: "red",
    rotation: -1.5,
  },
  {
    id: "a-2",
    title: "Horror, Superstition, and the Arab Imagination",
    slug: "horror-superstition-and-the-arab-imagination",
    publication: "This Is YUNG",
    category: "Film & Media",
    excerpt:
      "Why Arab horror turns inward \u2014 into questions of faith, morality, and the djinn within.",
    image:
      "https://images.pexels.com/photos/30713514/pexels-photo-30713514.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940",
    accent: "black",
    rotation: 1.2,
  },
  {
    id: "a-3",
    title: "Sarah Sahabati\u2019s Vulnerability Is Not a Template",
    slug: "sarah-sahabatis-vulnerability-is-not-a-template",
    publication: "A Shot Magazine",
    category: "Cover Interview",
    excerpt:
      "The Palestinian model on visibility, exhaustion, and refusing to be flattened into someone else\u2019s aesthetic.",
    image:
      "https://images.pexels.com/photos/31167801/pexels-photo-31167801.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1100&w=940",
    accent: "pink",
    rotation: -2.4,
  },
  {
    id: "a-4",
    title: "Through His Lens: A Conversation with Youssef Eid",
    slug: "through-his-lens-a-conversation-with-youssef-eid",
    publication: "Scene Styled",
    category: "Fashion",
    excerpt:
      "The Egyptian fashion photographer on conceptual portraiture and the politics of looking.",
    image:
      "https://images.unsplash.com/photo-1604828538822-61187f1eb326?crop=entropy&cs=srgb&fm=jpg&w=900&q=85",
    accent: "red",
    rotation: 1.8,
  },
  {
    id: "a-5",
    title: "Maison Sa\u00e9di\u2019s Muse",
    slug: "maison-saedis-muse",
    publication: "Scene Styled",
    category: "Designer",
    excerpt:
      "On the Egyptian house dressing the new front row \u2014 craftsmanship as quiet rebellion.",
    image:
      "https://images.pexels.com/photos/30713508/pexels-photo-30713508.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940",
    accent: "pink",
    rotation: -0.8,
  },
  {
    id: "a-6",
    title: "Tara Babylon: Born of an Imaginary Aura",
    slug: "tara-babylon-born-of-an-imaginary-aura",
    publication: "Scene Styled",
    category: "Designer",
    excerpt:
      "The Iraq-British designer building futurewear from the bones of memory.",
    image:
      "https://images.unsplash.com/photo-1661264265507-8351c069b400?crop=entropy&cs=srgb&fm=jpg&w=900&q=85",
    accent: "black",
    rotation: 2.3,
  },
  {
    id: "a-7",
    title: "The Cairo Streetwear Edit",
    slug: "the-cairo-streetwear-edit",
    publication: "Scene Styled",
    category: "Edit",
    excerpt:
      "What the city wears when it isn\u2019t performing for anyone.",
    image:
      "https://images.pexels.com/photos/27206735/pexels-photo-27206735.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940",
    accent: "red",
    rotation: -1.7,
  },
  {
    id: "a-8",
    title: "Sophia Khalifeh on What It Means to Be \u2018Sexy\u2019 in 2024",
    slug: "sophia-khalifeh-on-what-it-means-to-be-sexy-in-2024",
    publication: "Scene Styled",
    category: "Cover Interview",
    excerpt:
      "The Lebanese photographer reframes desire through her own lens \u2014 unapologetic, deliberate, alive.",
    image:
      "https://images.unsplash.com/photo-1700150595270-499a1ce07804?crop=entropy&cs=srgb&fm=jpg&w=900&q=85",
    accent: "pink",
    rotation: 1.1,
  },
  {
    id: "a-9",
    title: "Okhtein at Ten: A Decade of Egyptian Cool",
    slug: "okhtein-at-ten-a-decade-of-egyptian-cool",
    publication: "Scene Styled",
    category: "Fashion",
    excerpt:
      "Inside the anniversary that turned a brand into a cultural archive.",
    image:
      "https://images.unsplash.com/photo-1513635409-925147d66f0d?crop=entropy&cs=srgb&fm=jpg&w=900&q=85",
    accent: "black",
    rotation: -2.1,
  },
  {
    id: "a-10",
    title: "Dara's Reveals Giant Cookie for V-Day With Magdi Yacoub Foundation",
    slug: "daras-reveals-giant-cookie-for-v-day-with-magdi-yacoub-foundation",
    publication: "Scene Eats",
    category: "Food & Culture",
    excerpt:
      "A Scene Eats feature on Dara's Valentine's Day collaboration with the Magdi Yacoub Foundation.",
    image:
      "https://images.pexels.com/photos/4110008/pexels-photo-4110008.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940",
    externalUrl:
      "https://sceneeats.com/Fresh/Dara-s-Reveals-Giant-Cookie-for-V-Day-With-Magdi-Yacoub-Foundation",
    accent: "pink",
    rotation: 0.9,
    sourceType: "external",
    published: true,
  },
  {
    id: "a-11",
    title: "Okhtein Circles Back to Siwa with SS25",
    slug: "okhtein-circles-back-to-siwa-with-ss25",
    publication: "YUNG MEA",
    category: "Fashion",
    excerpt:
      "A YUNG MEA fashion feature on Okhtein's SS25 collection and its return to Siwa as a creative reference.",
    image:
      "https://images.pexels.com/photos/9775837/pexels-photo-9775837.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940",
    externalUrl: "https://thisisyungmea.com/okhtein-circles-back-to-siwa-with-ss25/",
    accent: "red",
    rotation: -0.6,
    sourceType: "external",
    published: true,
  },
];

export const publications = [
  "THIS IS YUNG",
  "DAZED MENA",
  "A SHOT MAGAZINE",
  "ROLLING STONE MENA",
  "SCENE STYLED",
  "CAIRO SCENE",
  "SCENE NOISE",
  "SCENE NOW SAUDI",
  "Scene Eats",
  "YUNG MEA",
  "SceneNow",
  "International Music Summit",
  "SCENE TRAVELLER",
  "HOOG CULTURE",
  "INSITE OOH",
];

export const highlights = [
  {
    id: "h-1",
    stamp: "VIRAL",
    title: "The Habibification piece blew up",
    body:
      "19K+ likes on TikTok, 7.8K on Instagram. The article reframed an entire conversation about Arab sonic identity in global pop.",
  },
  {
    id: "h-2",
    stamp: "PANEL",
    title: "Invited to speak in Dubai",
    body:
      "Hosted a live panel about the cultural co-option of Arab music \u2014 sharing the stage with regional artists and curators.",
  },
  {
    id: "h-3",
    stamp: "REFERENCED",
    title: "Quoted in Rolling Stone MENA \u2014 with DJ Snake",
    body:
      "The reporting was cited inside a Rolling Stone MENA feature on DJ Snake, anchoring the magazine\u2019s analysis of borrowed sound.",
  },
  {
    id: "h-4",
    stamp: "GLOBAL",
    title: "Paris Fashion Week \u00d7 Cover Stories",
    body:
      "From PFW dispatches to international cover interviews for A Shot Magazine \u2014 leading conversations with world-class talent.",
  },
];

export const pullQuotes = [
  {
    id: "pq-1",
    text:
      "Middle Eastern aesthetics aren\u2019t a moodboard \u2014 they\u2019re a living archive, and someone has to write them down before they\u2019re flattened.",
    attribution: "Mai El Mokadem, on her beat",
  },
  {
    id: "pq-2",
    text:
      "I get bored really quickly. \u2014 DJ Snake, in conversation",
    attribution: "From the Habibification reporting",
  },
];

export const focusAreas = [
  "Arts & Culture",
  "Celebrity Cover Interviews",
  "Fashion & Designers",
  "Music & Sonic Identity",
  "Film & Media Commentary",
  "Internet & Youth Culture",
];

export const careerHighlights = [
  {
    year: "2026",
    title: "A Shot Magazine \u2014 Lead Interviews",
    body: "Leading deep-dive cover stories with world-class regional and global talent.",
  },
  {
    year: "2025",
    title: "Dazed MENA \u2014 Habibification Goes Viral",
    body: "Article on the co-option of Arab music breaks out across TikTok & IG; cited by Rolling Stone MENA.",
  },
  {
    year: "2025",
    title: "Dubai Panel Speaker",
    body: "Invited to speak on a live panel about Arab music identity and cultural ownership.",
  },
  {
    year: "2024",
    title: "This Is YUNG \u2014 Cultural Long-Reads",
    body: "Essays on horror, intimacy, and the gendered architecture of love in the Arab world.",
  },
  {
    year: "2024",
    title: "Scene Styled \u2014 Fashion Beat",
    body: "Cover stories on Sophia Khalifeh, Maison Sa\u00e9di, Tara Babylon, Okhtein, Hadia Ghaleb and more.",
  },
  {
    year: "2023",
    title: "Hoog Culture & Insite OOH",
    body: "Began with youth-culture pieces and outdoor advertising analysis \u2014 the foundations of the beat.",
  },
];

export const aboutBio = [
  "A versatile journalist at the intersection of media and the creative industry, I began my writing career analyzing outdoors advertising at Insite OOH and writing youth-culture pieces for Hoog Culture. From there I moved into fashion journalism at Scene Styled, before expanding my beat to encompass the cultural forces shaping music, identity, and style across the Middle East.",
  "My work has been featured in Dazed MENA, Rolling Stone MENA, This Is YUNG, and the MO4 network (Cairo Scene, Scene Noise, Scene Now Saudi/UAE, Scene Traveller). From media commentary to covering emerging designers and internet culture, my writing captures the energy of a region in constant evolution.",
  "I specialize in high-stakes, real-time storytelling. My reporting has documented many moments in the Egyptian creative scene \u2014 from Okhtein\u2019s 10-year anniversary and Jude Benhalim\u2019s The Whisper Echoes to the debut of Hadia Ghaleb\u2019s flagship store and Cairo Design Week.",
  "Now my work carries a global reach \u2014 from Paris Fashion Week coverage and international cover stories to deep-dive features for A Shot Magazine, where I lead interviews with world-class talent. By combining cultural insight with an expansive network of regional talent, I aim to produce journalism that informs, challenges, and captures the global influence of Middle Eastern aesthetics.",
];
